// "Open this claim and take me to the note."
//
// Same reasoning as claims/claimEditorTarget.js, which this rides alongside:
// Atlas has no router, the feature registry renders a page with a fixed prop
// set, and threading one more prop would mean editing A's files. So the intent
// travels through a module both sides import.
//
// This is not new state management (frontend.md): one module-scoped integer, no
// subscribers, no re-render semantics, read once on mount and cleared. It is
// deliberately NOT mirrored into sessionStorage — losing a scroll position on a
// refresh costs nothing, and a claim id is the only thing it would store.

let target = null;

/** Ask the editor's Notes pane to scroll itself into view when it next opens. */
export function setNotesTarget(claimId) {
  target = Number(claimId) || null;
}

/** True once, for the claim that was named. Clears itself. */
export function takeNotesTarget(claimId) {
  const id = Number(claimId) || null;
  if (!id || target !== id) return false;
  target = null;
  return true;
}

export function clearNotesTarget() {
  target = null;
}
